// extracted by mini-css-extract-plugin
module.exports = {"summary":"OverviewFiltersSummary_summary__cX__d","chips":"OverviewFiltersSummary_chips__YEtNW","nohits":"OverviewFiltersSummary_nohits__niSZF"};